<template>
  <div class="system-simulation-refund">
    <el-card class="box-card">
      <div class="text item">
        <el-form ref="form" :model="search" label-width="200px" label-position="left">
          <el-form-item :label="$t('customerService.mch_refund_order_id')" prop="mch_refund_order_id" required>
            <el-input v-model="search.mch_refund_order_id" size="small" :placeholder="$t('customerService.mch_refund_order_id')"
                      class="search-frame" autocomplete="off" clearable/>
          </el-form-item>
          <!--          <el-form-item :label="$t('system.refund_method')" prop="refund_category" required>-->
          <!--            <el-select v-model="search.refund_category" class="search-frame" size="small" clearable>-->
          <!--              <el-option-->
          <!--                v-for="(item,index) in refundStatusArr"-->
          <!--                :key="index"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item v-if="search.refund_category === '1'" :label="$t('data.refund_amount')" prop="refund_amount" required>-->
          <!--            <el-input v-model="search.refund_amount" size="small" :placeholder="$t('data.refund_amount')"-->
          <!--                      class="search-frame" autocomplete="off" clearable/>-->
          <!--          </el-form-item>-->
          <el-form-item :label="$t('merchantAccount.transaction_status')" prop="transaction_status" required>
            <el-select v-model="search.transaction_status" class="search-frame" size="small" clearable>
              <el-option
                v-for="(item,index) in refundTransactionStatusArr"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="listLoading" @click="onSubmit('form')">Submit</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import {simulationDynamicRefund} from '@/api/system/system'
import {refundStatusMap, simulateRefundTypeMap} from "@/utils/maps";

export default {
  name: 'System_simulation_dynamic_refund',
  data() {
    return {
      listLoading: false,
      search: {
        mch_refund_order_id: '',
        transaction_status: '',
        refund_category: null,
        refund_amount: null
      }
    }
  },
  computed: {
    refundStatusArr() {
      return refundStatusMap()
    },
    refundTransactionStatusArr() {
      return simulateRefundTypeMap()
    }
  },
  mounted() {

  },
  methods: {
    onSubmit(formName) {
      const params = {
        mch_order_id: this.search.mch_refund_order_id,
        transaction_status: Number(this.search.transaction_status),
      }
      if (!this.search.mch_refund_order_id || !this.search.transaction_status) {
        this.$message.warning('Both cannot be empty');
        return
      }
      this.listLoading = true
      simulationDynamicRefund(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
        }
      }).finally(() => {
        this.listLoading = false
      })
    }
  }
}
</script>

<style scoped>
.search-frame {
  width: 300px;
}

.system-simulation-refund {
  margin: 20px;
  background-color: #fff;
}
</style>
